module.exports = __webpack_public_path__ + "static/img/cont56 (2).d30e6ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont56 (2).jpg
// module id = vcIb
// module chunks = 0